<template>
  <svg class="callout" :style="{ top: y, left: x }" width="200" height="97" viewBox="0 0 200 97" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path class="callout__bubble" fill-rule="evenodd" clip-rule="evenodd" d="M4 0C1.79086 0 0 1.79086 0 4V80C0 82.2091 1.79086 84 4 84H87.1963L99.0966 95.9003C99.4871 96.2908 100.12 96.2908 100.511 95.9003L112.411 84H196C198.209 84 200 82.2091 200 80V4C200 1.79086 198.209 0 196 0H4Z" fill="#FFFBF1"/>
    <rect x="3" y="3" width="194" height="78" rx="2" fill="#F04F1E"/>
    <text class="callout__value" x="50%" y="36" text-anchor="middle" dominant-baseline="middle">{{ prediction }}</text>
    <text class="callout__label" x="50%" y="63" text-anchor="middle" dominant-baseline="middle">Median Housing Value</text>
  </svg>
</template>

<script>
import { mapState } from "vuex";
import { gsap } from "gsap";

const currency = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});

export default {
  name: "Callout",

  watch: {
    latitude() {
      this.revealPin();
    },

    longitude() {
      this.revealPin();
    }
  },

  computed: {
    ...mapState(["latitude", "longitude", "pin", "medianHouseValue"]),

    prediction() {
      return currency.format(this.medianHouseValue);
    },

    x() {
      return `${this.pin.x - 100}px`;
    },

    y() {
      return `${this.pin.y - 97}px`;
    }
  },

  methods: {
    revealPin() {
      this.popSound.play();
      gsap.fromTo(this.$el,
        {
          opacity: 0,
          y: 10
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.4,
          ease: "back.out(5)"
        }
      );
    }
  },

  mounted() {
    this.popSound = new Audio(require("@/assets/sounds/pop.mp3"));
    this.popSound.volume = 0.15;
  }
};
</script>

<style lang="scss" scoped>
.callout {
  position: absolute;
  z-index: 1000;
  filter: drop-shadow(0 2px 2px rgba(#000, 0.3));
}

.callout__value {
  font-size: 40px;
  font-weight: bold;
  fill: #fff;
  // fill: #2d2d2d;
  letter-spacing: -1px;
}

.callout__label {
  font-size: 12px;
  font-weight: bold;
  fill: #fff;
}
</style>